import { render, staticRenderFns } from "./fwdakahousenew.vue?vue&type=template&id=401b7061&class=component&"
import script from "./fwdakahousenew.vue?vue&type=script&lang=js&"
export * from "./fwdakahousenew.vue?vue&type=script&lang=js&"
import style0 from "./fwdakahousenew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('401b7061')) {
      api.createRecord('401b7061', component.options)
    } else {
      api.reload('401b7061', component.options)
    }
    module.hot.accept("./fwdakahousenew.vue?vue&type=template&id=401b7061&class=component&", function () {
      api.rerender('401b7061', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/renwu/fwdakahousenew.vue"
export default component.exports